export default "__VITE_ASSET__RPe_Nb43__"